export default __webpack_public_path__ + "static/media/bra.2230a808.png";